
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M10.94 4a6.94 6.94 0 015.552 11.104l3.222 3.229c.381.381.381 1 0 1.38a.974.974 0 01-1.287.082l-.091-.081-3.223-3.229A6.94 6.94 0 1110.94 4zm0 1.953a4.986 4.986 0 100 9.973 4.986 4.986 0 000-9.973z"}})])
          )
        }
      }
    